import React from 'react';
import CookbookMealDetailsContainer from './CookbookMealDetailsContainer';
import {
  useTimestamp,
  CookbookMealConnectorApollo,
  AddFavoriteCookbookMealConnectorApollo,
  RemoveFavoriteCookbookMealConnectorApollo,
  RateCookbookMealConnectorApollo,
} from '@front-activerse/common-components';
import { useParams } from 'react-router-dom';
import UnauthorizedException from '../../Unauthorized/UnauthorizedException';

interface ICookbookMealDetailsPage {
  cookbookNavigation: {
    path: string;
    translationKey: string;
  }[];
}

export const CookbookMealListPage: React.FC<ICookbookMealDetailsPage> = ({
  cookbookNavigation,
}) => {
  const { timestamp3 } = useTimestamp();
  const { mealId } = useParams();

  if (!mealId) {
    throw new Error('No mealId');
  }

  return (
    <CookbookMealConnectorApollo mealId={+mealId}>
      {(cookbookMealData: any) =>
        !cookbookMealData.loading && cookbookMealData.meal?.viewerAccess?.canView === false ? (
          <UnauthorizedException mealPlanNavigation={cookbookNavigation} />
        ) : (
          <AddFavoriteCookbookMealConnectorApollo>
            {({ addCookbookMealToFavorite }: { addCookbookMealToFavorite: any }) => (
              <RemoveFavoriteCookbookMealConnectorApollo>
                {({
                  removeCookbookMealFromFavorites,
                }: {
                  removeCookbookMealFromFavorites: any;
                }) => (
                  <RateCookbookMealConnectorApollo>
                    {({ rateMeal }: { rateMeal: any }) => (
                      <CookbookMealDetailsContainer
                        {...cookbookMealData}
                        addToFavorites={addCookbookMealToFavorite}
                        removeFromFavorites={removeCookbookMealFromFavorites}
                        rateMeal={rateMeal}
                        key={timestamp3}
                      />
                    )}
                  </RateCookbookMealConnectorApollo>
                )}
              </RemoveFavoriteCookbookMealConnectorApollo>
            )}
          </AddFavoriteCookbookMealConnectorApollo>
        )
      }
    </CookbookMealConnectorApollo>
  );
};

export default CookbookMealListPage;
